import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=29b1f084&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"
import style0 from "./Collection.vue?vue&type=style&index=0&id=29b1f084&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.46.0__css-load_ecc709542230bcceb67dd6366ef941ae/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b1f084",
  null
  
)

export default component.exports